import { render, staticRenderFns } from "./RedactorWysiwyg.vue?vue&type=template&id=b41df07a&"
import script from "./RedactorWysiwyg.vue?vue&type=script&lang=js&"
export * from "./RedactorWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./RedactorWysiwyg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports